import styles from './switch.module.scss';

interface OwnProps {
    disabled: boolean;
    defaultChecked: boolean;
    name: string;
    label: string;
    onChange?: () => void;
}

export function Switch({disabled, defaultChecked, name, label, onChange}: OwnProps) {
    return (
        <div className={styles.switch}>
            <input
                id={name}
                type="checkbox"
                name={name}
                disabled={disabled}
                defaultChecked={defaultChecked}
                onChange={onChange}
            />
            <label htmlFor={name}>{label}</label>
        </div>
    );
}
